<template>
  <v-row justify="center" align="center">
    <v-col :cols="10">
      <div :class="{ 'survey-heading': !$vuetify.breakpoint.xs }">
        <br />
        <h1 class="text-center">{{ $t("message.survey") }}</h1>
        <br />
        <h4 class="text-center">
          <span v-html="$t('message.slideOneBrowserSupport')"></span>
        </h4>
      </div>
      <br />
      <v-expansion-panels focusable v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideSixTitle") }}-1</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <TellUsAboutYou />
            <div class="text-center">
              <v-btn
                class="white--text"
                color="#015594"
                @click="goToNextQuestion"
              >
                {{ $t("message.continue") }}
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideSixTitle") }}-2</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <LiveWorkPlayMap style="width: 100%" />
            <div class="text-center">
              <v-btn
                class="white--text"
                color="#015594"
                @click="goToNextQuestion"
              >
                {{ $t("message.continue") }}
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideEightTitle") }}-1</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <TransportationNeedsExercise2 />
            <div class="text-center">
              <v-btn
                class="white--text"
                color="#015594"
                @click="goToNextQuestion"
              >
                {{ $t("message.continue") }}
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideEightTitle") }}-2</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <ConcerningLocationsMap />
            <v-checkbox
              v-model="transportationComments"
              :label="$t(`message.slideNineExtraCommentsCheckText`)"
            ></v-checkbox>
            <TransportationCommentFields v-if="transportationComments" />
            <div class="text-center">
              <v-btn
                class="white--text"
                color="#015594"
                @click="goToNextQuestion"
              >
                {{ $t("message.continue") }}
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>{{
            $t("message.slideTenTitle")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <TransportationPriorities />
            <div class="text-center">
              <v-btn
                class="white--text"
                color="#015594"
                @click="goToNextQuestion"
              >
                {{ $t("message.continue") }}
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideElevenTitle") }}-1</v-expansion-panel-header
          >
          <v-expansion-panel-content class="survey-panel">
            <div>
              <PopulationGrowth survey-mode />
              <div class="text-center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextQuestion"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideElevenTitle") }}-2</v-expansion-panel-header
          >
          <v-expansion-panel-content class="survey-panel">
            <div>
              <EmploymentGrowth survey-mode />
              <div class="text-center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextQuestion"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideElevenTitle") }}-3</v-expansion-panel-header
          >
          <v-expansion-panel-content class="survey-panel">
            <div>
              <FutureCongestion survey-mode />
              <div class="text-center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextQuestion"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideElevenTitle") }}-4</v-expansion-panel-header
          >
          <v-expansion-panel-content class="survey-panel">
            <div>
              <ExistingPlannedTransit survey-mode />
              <div class="text-center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextQuestion"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideElevenTitle") }}-5</v-expansion-panel-header
          >
          <v-expansion-panel-content class="survey-panel">
            <div>
              <ExistingPlannedFacility survey-mode />
              <div class="text-center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextQuestion"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideSeventeenTitle") }}-1</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <Exercise5Map />
            <div class="text-center">
              <v-btn
                class="white--text"
                color="#015594"
                @click="goToNextQuestion"
              >
                {{ $t("message.continue") }} </v-btn
              >`
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >{{ $t("message.slideSeventeenTitle") }}-2</v-expansion-panel-header
          >
          <v-expansion-panel-content class="survey-panel">
            <div>
              <RegionNeeds survey-mode />
              <div class="text-center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextQuestion"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="text-center">
          <v-expansion-panel-header>{{
            $t("message.slideTwentyCompleteWorkshopBtn")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <br />
            <h1>
              {{ $t(`message.slideTwentyTitle`) }}
            </h1>
            <br />
            <p>
              {{ $t(`message.slideTwentyCompleteWorkshopInstructions`) }}
            </p>
            <CompleteWorkshopButton />
            <v-divider></v-divider><br />
            <p>
              {{ $t(`message.slideTwentyHowWasExperienceInfo`) }}
            </p>
            <div class="pa-md-4 mx-lg-auto">
              <v-btn @click.stop="showExperienceDialog = true">{{
                $t(`message.slideTwentyHowWasExperienceBtn`)
              }}</v-btn>
            </div>
            <br />
            <v-divider></v-divider><br />
            <CommentForm />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-dialog v-model="showExperienceDialog" width="500">
          <HowWasYourExperience
            :toggleDialog="toggleExperienceDialog"
            :dialogBoolean="showExperienceDialog"
          />
        </v-dialog>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import LiveWorkPlayMap from "@/components/LiveWorkPlayMap.vue";
import ConcerningLocationsMap from "@/components/ConcerningLocationsMap.vue";
import TransportationCommentFields from "@/components/TransportationCommentFields.vue";
import TransportationPriorities from "@/components/TransportationPriorities.vue";
import CommentForm from "@/components/CommentForm.vue";
import HowWasYourExperience from "@/components/HowWasYourExperience.vue";
import Exercise5Map from "@/components/Exercise5Map.vue";
import PopulationGrowth from "@/components/Exercise 4/PopulationGrowth.vue";
import EmploymentGrowth from "@/components/Exercise 4/EmploymentGrowth.vue";
import FutureCongestion from "@/components/Exercise 4/FutureCongestion.vue";
import ExistingPlannedTransit from "@/components/Exercise 4/ExistingPlannedTransit.vue";
import ExistingPlannedFacility from "@/components/Exercise 4/ExistingPlannedFacility.vue";
import TellUsAboutYou from "@/components/TellUsAboutYou.vue";
import TransportationNeedsExercise2 from "@/components/TransportationNeedsExercise2.vue";
import RegionNeeds from "@/components/RegionNeeds.vue";
import CompleteWorkshopButton from "@/components/CompleteWorkshopButton.vue";

export default {
  name: "Workshop",
  components: {
    LiveWorkPlayMap,
    ConcerningLocationsMap,
    TransportationCommentFields,
    TransportationPriorities,
    CommentForm,
    HowWasYourExperience,
    Exercise5Map,
    PopulationGrowth,
    EmploymentGrowth,
    FutureCongestion,
    ExistingPlannedTransit,
    ExistingPlannedFacility,
    TellUsAboutYou,
    TransportationNeedsExercise2,
    CompleteWorkshopButton,
    RegionNeeds
  },
  data: () => ({
    showExperienceDialog: false,
    transportationComments: false,
    toggleSurvey: false,
    panel: 0
  }),
  methods: {
    toggleExperienceDialog() {
      this.showExperienceDialog = !this.showExperienceDialog;
    },
    goToNextQuestion() {
      this.panel++;
    }
  }
};
</script>

<style>
.survey-panel {
  background: url("../../public/static/Wall.png") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
}
.survey-heading {
  max-width: 50%;
  margin-left: 25%;
}
</style>
